import { FaUserPlus, FaBitcoin, FaMoneyBillWave, FaLock, FaPhoneAlt, FaEnvelope, FaRegCalendarAlt, FaUser } from "react-icons/fa";
import './HowItWorks.css';

export const HowItWorks = () => {
    const Step = ({ title, description, icon: Icon, aos }) => (
        <div className="step" data-aos={aos}>
            <div className="text-side">
                <h2>{title}</h2>
                <p>{description}</p>
            </div>
            <div className="icon-side">
                <Icon className="step-icon large" />
            </div>
        </div>
    );

    return (
        <div className="how-it-works-container">
            <h1 className="main-heading" data-aos="zoom-in">How It Works</h1>

            <Step
                title="Registration"
                aos="fade-right"
                icon={FaUserPlus}
                description={
                    <>
                        Creating an account on <strong>Cloud9</strong> is fast, secure, and effortless. All you need is:
                        <ul>
                            <li><FaEnvelope className="inline-icon" /> Email Address</li>
                            <li><FaUser className="inline-icon" /> Full Name</li>
                            <li><FaRegCalendarAlt className="inline-icon" /> Date of Birth</li>
                            <li><FaPhoneAlt className="inline-icon" /> Mobile Number</li>
                            <li><FaLock className="inline-icon" /> A secure 6-digit password</li>
                        </ul>
                        <p>After submitting the form, your account is activated instantly — no ID or documents required!</p>
                        <p>🎉 You’re now ready to explore and play on the hottest crypto casino platforms!</p>
                    </>
                    
                }
                
            />
             <div className="register-button-container" data-aos="zoom-in">
    <a href="/register" className="register-now-button">
        🚀 Register Now
    </a>
</div>
           


            <Step
                title="Deposit"
                aos="fade-left"
                icon={FaBitcoin}
                description={
                    <>
                        Top-up your Cloud9 account securely using Bitcoin:
                        <ul>
                            <li>🎰 Select the platform where you want to play</li>
                            <li>💵 Choose your deposit amount (min $10)</li>
                            <li>📲 Copy the wallet address or scan the QR code</li>
                            <li>⏳ Wait for blockchain confirmation (usually takes minutes)</li>
                        </ul>
                        <p>Once confirmed, your funds are instantly added to your balance — no delays, no complications.</p>
                        <p>🪙 Get ready to dive into action!</p>
                    </>
                }
            />

            <Step
                title="Withdrawal"
                aos="fade-right"
                icon={FaMoneyBillWave}
                description={
                    <>
                        Ready to cash out your winnings? We’ve made it smooth and easy:
                        <ul>
                            <li>💰 Open the <strong>Withdrawal</strong> section</li>
                            <li>🔗 Paste your Bitcoin wallet address</li>
                            <li>✍️ Enter your desired amount</li>
                            <li>🕒 Your request is processed within 8 hours</li>
                        </ul>
                        <p>💸 Funds are transferred directly to your wallet without fees or hold-ups!</p>
                        <p>🎊 It’s your money — enjoy it your way!</p>
                    </>
                }
            />
            <div className="register-button-container" data-aos="zoom-in">
    <a href="mailto:info@cloud9pro.net" className="register-now-button">
        📞 Contact Us 
    </a>
</div>
        </div>
    );
};
